<template>
  <div :class="[{ purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit" class="form">
      <div class="form__item">
        <CustomSelect :options="this.floorTypeOptions" optionValueKey="value" optionLabelKey="label"
          :value="this.formData.floorType" @change="(value) => onChange('floorType', value)" label="Тип этажа"
          :required="true" />
      </div>
      <div class="form__item" v-if="this.formData.floorType === 'residential'">
        <CustomInput :required="true" label="Номер этажа (от 1 до 50)" type="number" :value="this.formData.level_num"
          @change_input="(value) => onChange('level_num', value)" allowNegative="false" :min="1" :max="50" />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import { useAppStore } from "@/services/store/app";

export default {
  name: "add-project-floor",
  components: { CustomInput, CustomModalFooter, CustomSelect },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        level_num: 0,
        floorType: null
      },
      floorMaps: [],
      floorTypeOptions: [
        { label: 'Жилой этаж', value: 'residential' },
        { label: 'Подвал', value: 'basement' },
        { label: 'Кровля', value: 'roof' }
      ],
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
      if (key === 'floorType' && value !== 'residential') {
        this.formData.level_num = 0
      }
    },
    async onSubmit() {
      if (!this.formData.floorType) {
        return;
      }

      let level_num = 0;

      if (this.formData.floorType === 'residential') {
        if (!this.formData.level_num || this.formData.level_num < 1 || this.formData.level_num > 50) {
          return;
        }
        level_num = parseInt(this.formData.level_num);
      } else if (this.formData.floorType === 'basement') {
        level_num = -1000;
      } else if (this.formData.floorType === 'roof') {
        level_num = 1000;
      }

      const payload = {
        level_num: level_num,
        project_entrance_id: this.data?.body?.project_entrance_id,
        project_id: this.data?.body?.project_id,
        entrance_id: this.data?.body?.entrance_id,
      }
      if (this.data?.body?.floor_map_id) {
        payload.floor_map_id = this.data?.body?.floor_map_id
      }
      this.loading = true
      const res = await this.data?.onSubmit(payload)
      this.loading = false
      if (res !== false) {
        this.closeModal?.()
      }
    }
  },
  mounted() {
    if (this.data?.body) {
      const { level_num } = this.data.body
      this.formData.level_num = level_num ?? 0
    }
  },
  setup() {
    const { closeModal } = useAppStore()
    return { closeModal }
  }
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  gap: 15px;

  &__item {
    &_file {
      padding: 10px 7px;
      border-radius: 4px;
      border: 1px solid #ccc;
      color: #1f5ac2;

      &Label {
        margin-bottom: 3px;
        font-size: 13px;
        display: block;
        color: #3b3b3b;
      }
    }
  }

  @media (max-width: 428px) {
    min-width: 100%;
  }
}
</style>
